import { Brand, BrandIndexItem } from "@/api/braendz";

export function getBrandLogoUrl(brand: BrandIndexItem | Brand | null | undefined): string | null {
    const url = brand?.brandLogoUrl;
    if (url) {
        return getBrandLogoUrlByRelativeUrl(url);
    }
    return null;
}

export function getBrandLogoUrlByRelativeUrl(url: string): string {
    if (/^(?:[a-z+]+:)?\/\//i.test(url)) {
        // Case e.g. for ES: URL is absolute and can be requested directly:
        return url;
    } else {
        // Normal case: URL is relative and needs to be requested via API:
        return `${process.env.VUE_APP_BRAENDZ_API_BASE_URL
            }/api/v1/BrandImages/${Buffer.from(url).toString(
                "base64"
            )}?base64Encoded=true`;
    }
}

export const registrationOfficeCodeRelationships = [
    { key: "DE", related: ["EM"] },
    { key: "AT", related: ["EM"] },
    { key: "CH", related: [] },
    { key: "FR", related: ["EM"] },
    { key: "ES", related: ["EM"] },
    { key: "EM", related: ["DE", "AT", "FR", "ES"] },
    { key: "US", related: [] },
];